import { useChatStore } from "@metalmind-ab/mmagent-chat-ui";

/** Settle the submitted bubble at confirmed Stop, including tools added while awaiting the server. */
export function settleCancelledToolExecutions(messageId: string | null): void {
  if (!messageId) return;
  const state = useChatStore.getState();
  const message = state.messages.find(
    (candidate) => candidate.id === messageId,
  );
  for (const execution of message?.toolExecutions ?? []) {
    if (execution.status === "running") {
      state.updateToolExecutionInMessage(messageId, execution.id, {
        status: "error",
        error: "Cancelled",
      });
    }
  }
}
